import M$plugin$CatalogSearch from './/facade/js/catalogsearch';

if (!window.M.plugin) window.M.plugin = {};
window.M.plugin.CatalogSearch = M$plugin$CatalogSearch;
